import { Injectable, signal } from '@angular/core';

/**
 * The channel currently selected in the frontend filter row.
 *
 * Root-provided so any post widget — the carousel, the latest-posts list, the
 * feed, and whatever is added next — can react to the selection without the
 * home page plumbing inputs and outputs between siblings.
 *
 * Single-select even though a post may belong to several channels: `All` plus
 * one chip keeps the store, the query param and the chip row simple, and
 * avoids the "zero selected vs all selected" ambiguity a multi-select has.
 *
 * Session state only: it survives navigation (returning to a silently reset
 * page would undo a choice the user never revoked) but is deliberately not
 * persisted to the URL or `localStorage`, so a fresh load starts at `All`.
 */
@Injectable({ providedIn: 'root' })
export class PostFilterStore {
  /** Channel id, or `null` for `All`. */
  readonly channel = signal<string | null>(null);
}
